import { Box, Grid, Typography } from "@mui/material";

import { AccountDetail } from "components/AccountDetail";
import { PasswordChange } from "components/PasswordChange";
import RightContent from "components/wrappers/RightContent";

export const Account = () => {
  return (
    <RightContent>
      <Grid container >
        <Typography variant="h1">Your Primary Account</Typography>
        <Box mt={2} mb={5}>
          <AccountDetail />
        </Box>
        <Grid item xs={12} md={6}>
          <PasswordChange />
        </Grid>
      </Grid>
    </RightContent>
  );
};
